import { ToastProgrammatic as Toast } from 'buefy';
import { TOAST_TYPES } from "@/global/toast";
import { confirmation } from "@/global/utils";
import { getContextOptions } from '@/helpers/endpoints';

export default {
  ...getContextOptions(this),
  info(message) {
    Toast.open({ message: this.getTranslatedKey(message, message), type: TOAST_TYPES.INFO });
  },
  ok(message) {
    Toast.open({ message: this.getTranslatedKey(message, message), type: TOAST_TYPES.SUCCESS });
  },
  error(message, duration) {
    Toast.open({ message: this.getTranslatedKey(message, message), type: TOAST_TYPES.ERROR, duration });
  },
  open(message, type = TOAST_TYPES.INFO) {
    Toast.open({ message: this.getTranslatedKey(message, message), type });
  },
  ask(context, message) {
    return confirmation(context, message, "global.askConfirmationTitle");
  }
};
